import React from 'react';
import { Package } from 'lucide-react';

const DoublePackageIcon = React.forwardRef<HTMLDivElement, { size?: number; color?: string; strokeWidth?: number; className?: string }>(
  ({ size = 10, color = 'currentColor', strokeWidth = 2.5, ...props }, ref) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }} {...props} ref={ref}>
      <Package size={14} color={color} strokeWidth={strokeWidth} />
      <Package size={14} color={color} strokeWidth={strokeWidth} />
    </div>
  )
);

export default DoublePackageIcon;
